import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  listRewardUser,
  // updateReward,
} from "../../Redux/Actions/rewardsAction";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";
import { columnsRewardsUserPoints } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";

const ListUserRewards = () => {
  const dispatch = useDispatch();
  const [tempSearch, setTempSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        filter: searchQuery,
      };
      dispatch(listRewardUser(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh Reward User List");
        }
      });
    },
    [dispatch, searchQuery]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  const rewardPoints = useSelector((state) => state.rewards?.doneUserList || {});
  const loading = useSelector((state) => state.rewards?.loading);

  useEffect(() => {
    if (rewardPoints?.total) {
      setPagination((prev) => ({
        ...prev,
        total: rewardPoints.total,
      }));
    }
  }, [rewardPoints]);

  const handleTableChange = (pager) => {
    setPagination(pager);
    // fetchDetails(pager.current, pager.pageSize);
  };

  const filterHandler = () => {
    setSearchQuery(tempSearch);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleStatusChange = async (record, action) => {
    if (action === "active" || action === "inactive") {
      const payload = {
        id: record._id,
        status: action,
      };
      // await dispatch(updateReward(payload));
      fetchDetails(pagination.current, pagination.pageSize);
    }
  };

  return (
    <TableComponentsCp
      h3heading="Reward User List"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsRewardsUserPoints(handleStatusChange)}
      // buttonhead2="Add Reward Points"
      // navigateTo2="/reward-points/add"
      dataSource={Array.isArray(rewardPoints?.data) ? rewardPoints.data : []}
      loading={loading}
      setState={setTempSearch}
      filterFunction={filterHandler}
      onPressEnter={filterHandler}
    />
  );
};

export default ListUserRewards;
